import React from 'react';
import {useForm} from "@inertiajs/inertia-react";

const PublicCoupon = (id) => {
const {put} = useForm({ id: id });
  const handlePublished = () => {
    put(route('added.coupons.published', id).url());
  }

  return (
    <>
      <div className="modal-body">
        Do you want this coupon to show online?
      </div>
      <div className="modal-footer flex justify-end">
        <button onClick={handlePublished} className="btn-default bg-green-700 focus:outline-none py-2 px-4">
          <span>Yes</span>
        </button>
      </div>
    </>
  );
};

export default PublicCoupon;
